import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "text-center text-roman mt-x3 mb-x6 sm:mb-0"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "mx-auto max-w-750 mb-x6 sm:mb-0"
}

import { useCheckout } from '../../useCheckout';
import { computed, onMounted, ref, watch, withDefaults } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { usePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import CheckoutPaymentFinalize from '@/b2b/checkout/ui/payment/CheckoutPaymentFinalize.vue';
import useScrollToElement from '@/shared/navigation/useScrollToElement';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import useScrollIntoView from '@/shared/navigation/useScrollIntoView';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentOptions',
  props: {
    isClientValid: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isClientValid: boolean }



const labels = useBlockLabels();
const pending = ref<boolean>(false);
const { basket, items, initializePayment, setItemIdsOutOfStock, hasSufficientPayments, setEarliestDeliveryDateChanged, submitOrderWithSufficientPaymentsInBasket } = useCheckout();
const { options, providerError, clearProviderError } = usePaymentOptions();

const altaPayRedirectData = useRouteQuery<string>(QueryKeys.AltaPayRedirectData);
const isAwaitingPotentialErrorState = computed<boolean>(() => {
    return !!altaPayRedirectData.value;
});

const isValidForPayment = computed<boolean>(() => {
    const emptyBasket = items.value.length < 1;
    const invalidDeliverable = basket.value?.deliverables.find(deliverable => !deliverable.isValid);
    const serverInvalid = !!invalidDeliverable;
    const clientInvalid = !props.isClientValid;
    return !serverInvalid && !clientInvalid && !emptyBasket;
});

const togglePaymentOptions = ref<boolean>(false);
const showPaymentOptions = computed<boolean>(() => {
    return isValidForPayment.value && togglePaymentOptions.value;
});
const scrollToProviderError = ref<boolean>(false);
const scrollToPaymentStep = computed<boolean>(() => showPaymentOptions.value && !isAwaitingPotentialErrorState.value);
const paymentElementToScrollToWhenActive = useScrollToElement(scrollToPaymentStep, -50);
const ensureErrorInViewElement = useScrollIntoView(scrollToProviderError);

const initiatePayment = async() => {
    pending.value = true;
    clearProviderError();
    const result = await initializePayment();
    if (result.itemsOutOfStock?.length) {
        setItemIdsOutOfStock(result.itemsOutOfStock);
    } else if (result.requiredEarliestDeliveryDate) {
        setEarliestDeliveryDateChanged(true);
    } else if (hasSufficientPayments.value) {
        await submitOrderWithSufficientPaymentsInBasket();
    } else {
        togglePaymentOptions.value = true;
    }
    pending.value = false;
};

const maybeInitializePaymentOptions = () => {
    if (altaPayRedirectData.value) {
        togglePaymentOptions.value = true;
        clearProviderError();
    }
};

onMounted(maybeInitializePaymentOptions);

watch(() => isValidForPayment.value && !providerError.value, (valid) => {
    if (!valid) {
        togglePaymentOptions.value = false;
    }
});
watch(providerError, value => {
    // delay to ensure element is rendered before scroll
    // needed for redirect payment types
    setTimeout(() => scrollToProviderError.value = value, 500);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { ref: _unref(ensureErrorInViewElement) }, [
    (!_unref(showPaymentOptions))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["w-full text-center mb-x6", { 'opacity-50': !_unref(isValidForPayment) }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "c-button c-button--primary mx-auto",
            disabled: !_unref(isValidForPayment) || pending.value,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (initiatePayment()), ["prevent"]))
          }, _toDisplayString(_unref(hasSufficientPayments) ? _unref(labels).paymentStepButtonPlaceOrder : _unref(labels).paymentStepButtonGotoPayment), 9, _hoisted_1),
          _createVNode(_Transition, { name: "o-anim-fade-300" }, {
            default: _withCtx(() => [
              (_unref(providerError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h4", null, _toDisplayString(_unref(labels).paymentStepProcessingErrorDescription), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    (!_unref(hasSufficientPayments))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", {
            ref: _unref(paymentElementToScrollToWhenActive),
            class: _normalizeClass(["mb-x6 text-center transition-colors duration-300", {'text-silver': !_unref(showPaymentOptions)}])
          }, _toDisplayString(_unref(labels).paymentStepHeading), 3),
          _createVNode(_Transition, { name: "o-anim-fade-300" }, {
            default: _withCtx(() => [
              (_unref(showPaymentOptions))
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(BlockList, {
                      blocks: _unref(options),
                      nested: true,
                      class: "mb-x6"
                    }, null, 8, ["blocks"]),
                    _createVNode(CheckoutPaymentFinalize)
                  ], 512)), [
                    [_vShow, !_unref(isAwaitingPotentialErrorState)]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})